import React from 'react';
import PropTypes from 'prop-types';
import SuccessHeader from './SuccessHeader';
import BroadbandCompareTrackingPixelContainer from '../../redux/containers/BroadbandCompareTrackingPixelContainer';
import SuccessFooter from './SuccessFooter';
import RatebrokerService from '../../services/RatebrokerService';
import './Success.scss';
import PlanUtilities from '../../services/PlanService';
import PageHeader from '../PageHeader/PageHeader';
import Service from '../../services/SubscriptionDiscountService';


const isPartner = (partner, name) => partner && partner.name
  .toLowerCase()
  .includes(name);

class Success extends React.Component {
  constructor(props) {
    super(props);
    this.isByoFlag = false;
    if (!this.isByoFlag) {
      this.prevIsByoModemSelected = props.isByoModemSelected;
    }
  }
  componentWillMount() {
    const { partner } = this.props;
    if (isPartner(partner, 'ratebroker')) {
      RatebrokerService.postLeadKey(partner.leadKey, 'completed');
    }
  }

  componentWillUnmount() {
    this.isByoFlag = true;
    this.props.clearSuccessDetails();
  }

  render() {
    const {
      partner, isFixedTerm, discountWithSubscription, plan, offer, isUfbAvailable, isUfbReady,
      isCovid19Mode

    } = this.props;

    const credit = PlanUtilities.getCredit(this.props.isFixedTerm);
    const hasSubscriptionDiscount = Service.hasDiscountWithSubscription(isFixedTerm, discountWithSubscription);
    return (
      <main>
        <PageHeader title={'All Done'} />
        <SuccessHeader
          credit={credit}
          plan={plan}
          offer={offer}
          hasSubscriptionDiscount={hasSubscriptionDiscount}
          withMobileDiscount={this.props.withMobileDiscount}
          isByoModemSelected={this.prevIsByoModemSelected}
        />
        <SuccessFooter
          hasSubscriptionDiscount={hasSubscriptionDiscount}
          isUfbReady={isUfbReady}
          isUfbAvailable={isUfbAvailable}
          isCovid19Mode={isCovid19Mode}
          isByoModemSelected={this.prevIsByoModemSelected}
        />
        {
          isPartner(partner, 'broadbandcompare')
            ? <BroadbandCompareTrackingPixelContainer />
            : null
        }
      </main>
    );
  }
}

Success.propTypes = {
  partner: PropTypes.object,
  clearSuccessDetails: PropTypes.func.isRequired,
  isFixedTerm: PropTypes.bool.isRequired,
  plan: PropTypes.object,
  offer: PropTypes.object,
  discountWithSubscription: PropTypes.object,
  isUfbReady: PropTypes.bool,
  isUfbAvailable: PropTypes.bool,
  isCovid19Mode: PropTypes.bool,
  withMobileDiscount: PropTypes.bool,
  isByoModemSelected: PropTypes.bool,
};

export default Success;



/** WEBPACK FOOTER **
 ** ./src/components/Success/Success.js
 **/